import api from "./api";

export const listQuickAnswerCategories = async () => {
  const { data } = await api.get("/quickAnswerCategories");
  return data;
};

export const createQuickAnswerCategory = async (categoryData) => {
  const { data } = await api.post("/quickAnswerCategories", categoryData);
  return data;
};

export const updateQuickAnswerCategory = async (id, categoryData) => {
  const { data } = await api.put(`/quickAnswerCategories/${id}`, categoryData);
  return data;
};

export const deleteQuickAnswerCategory = async (id) => {
  const { data } = await api.delete(`/quickAnswerCategories/${id}`);
  return data;
};
